import {
  IConfirmEmail,
  IRecoverPassword,
  ISurvey,
  IUser,
  IUserLogin,
  IUserSignUp,
  IUserUpdate,
} from '../interfaces/interfaces'
import { api } from '../lib/axios'

const clearHeader = () => {
  api.defaults.headers.common['Authorization'] = ''
}

const signup = (user: IUserSignUp) => {
  clearHeader()
  return api.post('/users', user)
}

const update = (user: IUserUpdate) => {
  return api.put('/users', user)
}

const login = (user: IUserLogin) => {
  clearHeader()
  return api.post('/login', user)
}

const forgotPassword = (email: string) => {
  clearHeader()
  return api.post(`/users/send-code-recover-password/email/${email}`)
}

const recoverPassword = (recoverPassword: IRecoverPassword) => {
  clearHeader()
  return api.post(`/users/reset-password`, recoverPassword)
}

const confirmEmail = (confirmEmail: IConfirmEmail) => {
  clearHeader()
  return api.post(`/users/confirm-email`, confirmEmail)
}

const resendEmail = (confirmEmail: IConfirmEmail) => {
  clearHeader()
  return api.post(`/users/resend-email`, confirmEmail)
}

const isAuthenticated = () => {
  const token = localStorage.getItem('@sec-auspex-tk')
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token)}`
  }
  return token ? true : false
}

const getAuthenticatedUser = (): IUser => {
  return JSON.parse(localStorage.getItem('@sec-auspex-user') || '{}')
}

const setTutorialCompleted = () => {
  return api.post(`/users/update-tutorial`)
}

const logout = () => {
  localStorage.removeItem('@sec-auspex-tk')
}

const createSurvey = (survey: ISurvey) => {
  return api.post('/survey', survey)
}

const AuthService = {
  signup,
  update,
  login,
  isAuthenticated,
  logout,
  forgotPassword,
  recoverPassword,
  confirmEmail,
  resendEmail,
  getAuthenticatedUser,
  setTutorialCompleted,
  createSurvey,
}

export default AuthService
